import {DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {SlideDialog} from "./SlideDialog";
import React from "react";
import PropTypes from "prop-types";


export default function StandardDialogSlide(props) {
    const {open, onClose, actions, title, children, ...other} = props;
    return (
        <SlideDialog
            {...other}
            open={open}
            onClose={onClose}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                {actions}
            </DialogActions>
        </SlideDialog>
    );
}

StandardDialogSlide.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    actions: PropTypes.arrayOf(PropTypes.node).isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.any
}